import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { OrderStatusBadge } from './OrderStatusBadge';

export const OrdersTab = ({ orders, loadingOrders }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <Package className="w-5 h-5 text-yellow-400" />
        Order History
      </CardTitle>
    </CardHeader>
    <CardContent>
      {loadingOrders ? (
        <div className="text-center py-8">
          <Sparkles className="w-8 h-8 mx-auto text-yellow-400 animate-pulse" />
          <p className="text-purple-200 mt-2">Loading orders...</p>
        </div>
      ) : orders.length === 0 ? (
        <div className="text-center py-8">
          <Package className="w-16 h-16 mx-auto text-purple-500 mb-4" />
          <p className="text-purple-200 mb-4">No orders yet</p>
          <Link to="/products">
            <Button className="bg-yellow-500 hover:bg-yellow-600 text-purple-900">
              Start Shopping
            </Button>
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <div
              key={order.order_number}
              className="bg-purple-900/50 rounded-lg p-4 border border-purple-700"
              data-testid={`order-${order.order_number}`}
            >
              <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                <div>
                  <p className="text-white font-semibold">{order.order_number}</p>
                  <p className="text-purple-300 text-sm">
                    {new Date(order.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </p>
                </div>
                <div className="flex items-center gap-4">
                  <OrderStatusBadge status={order.status} />
                  <span className="text-yellow-400 font-bold">
                    ${order.pricing?.total?.toFixed(2)}
                  </span>
                </div>
              </div>
              <div className="border-t border-purple-700 pt-4">
                <p className="text-purple-200 text-sm mb-2">Items:</p>
                <div className="space-y-2">
                  {order.items?.map((item, idx) => (
                    <div key={`${order.order_number}-item-${idx}`} className="flex justify-between text-sm">
                      <span className="text-purple-100">
                        {item.name} ({item.size}) x{item.quantity}
                      </span>
                      <span className="text-purple-300">
                        ${(item.price * item.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
